import React, { useEffect, useReducer } from 'react'

import { useFormContext } from 'react-hook-form'
import { isEmpty } from 'lodash'
import { Box, Typography } from '@material-ui/core'

import { FileUploadInput } from 'components'

import constants from 'constants/index'

// Campo de evidência por resposta. Reaproveita o FileUploadInput: o controllerBar
// é semeado com as evidências já salvas ({ id, url, name }) e os arquivos novos
// ficam no formulário como instâncias de File. Quando onUpload é informado, eles
// são enviados na hora da seleção; sem ele, quem envia é o submit do formulário.
// A remoção de evidências já salvas passa pelo onRemoveApiFile (usa o id).
const PrivacyByDesignEvidenceField = ({
  answerId,
  controlName = `evidence_${answerId}`,
  evidences = [],
  required = false,
  readOnly = false,
  loading = false,
  onUpload,
  onRemove,
}) => {
  const { watch, setValue } = useFormContext()
  // O setValue do react-hook-form v5 grava o valor no field ref sem garantir o
  // re-render do FileUploadInput (que lê o valor via watch).
  const [, forceRender] = useReducer((count) => count + 1, 0)

  const currentValue = watch(controlName)
  const savedEvidenceIds = evidences.map((evidence) => evidence.id).join(',')

  // Semeia o campo com as evidências já persistidas. A dependência é a lista de
  // ids (e não o array, recriado a cada render do pai) para não ressemear em
  // loop e apagar o arquivo recém-selecionado antes do upload.
  useEffect(() => {
    setValue(controlName, isEmpty(evidences) ? null : evidences)
    forceRender()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedEvidenceIds])

  // Envio imediato, quando o pai pede: depois do upload as evidências salvas
  // mudam e o efeito acima ressemeia o campo apenas com os itens persistidos.
  useEffect(() => {
    const newFiles = currentValue
      ? Array.from(currentValue).filter((file) => file instanceof File)
      : []

    if (!isEmpty(newFiles) && onUpload) onUpload(answerId, newFiles)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue])

  // Sem margem própria: o espaçamento entre os campos vem do container que
  // renderiza o campo, para não somar com o gap dele.
  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Evidência{required ? ' *' : ''}
      </Typography>
      <FileUploadInput
        controlName={controlName}
        maxSize={constants.validations.MAX_FILE_SIZE_15_MB}
        title="Arraste e solte ou selecione a evidência a ser anexada"
        accept={constants.validations.ALL_FILE_TYPES}
        multiple
        controllerBar
        hasDownloadFile
        loading={loading}
        disabled={readOnly}
        {...(!readOnly && {
          onRemoveApiFile: (evidenceId) => onRemove?.(answerId, evidenceId),
        })}
      />
    </Box>
  )
}

export default PrivacyByDesignEvidenceField
